import { curry } from 'lib/util'
import { read } from 'app/_shared/events/notification/message'

/**
 * Reads all notifications
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<{ data: Object[], page: string|null }>}
 * @private
 */
const _read = async (callback, module, component, event) => {
  const { page = null } = event?.detail || event || {}

  return await read(module, component, { page }, callback, event)
}

export default curry(_read)
